import React from "react"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { IHierarchyDefinition } from "../../../models"
import { Dialog, TextField, Toggle, FlatButton } from "material-ui"
import * as utils from "../../../helpers/utils"
import AccountStore from "../../../stores/AccountStore"
import accountStore from "../../../stores/AccountStore"
import { checkPositionFieldAvailable } from "../../../helpers/positionHelper"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"
interface IProps {
    candidateLevel: number
    explicitEmployeeHierarchyAssignment: boolean
    explicitAccountUserHierarchyAssignment: boolean
    handleSave(hierarchyDefinition: IHierarchyDefinition): void
    handleClose(): void
}
interface IState {
    name: string
    errorName: string
    enableLocations: boolean
    enableMicroLocations: boolean
    enablePositions: boolean
    enableEmployees: boolean
    enableAccountUsers: boolean
    disableExpense: boolean
    enablePunches: boolean
    enableJob: boolean
    messageForDisablePunches: string
    errorMessageForDisablePunches: string
}

export default class AddAccountHierarchyDefinitionDialog extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            name: "",
            errorName: "",
            enableLocations: false,
            enableMicroLocations: false,
            enablePositions: false,
            enableEmployees: false,
            enableAccountUsers: false,
            disableExpense: false,
            enablePunches: false,
            enableJob: false,
            messageForDisablePunches: strings.Punches_are_not_allowed_at_this_location,
            errorMessageForDisablePunches: "",
        }
        autobind(this)
    }

    handleSave() {
        if (!this.checkValidate()) return
        const newHierarchyDefinitionItem: IHierarchyDefinition = {
            Id: utils.guid(),
            Level: this.props.candidateLevel,
            Label: this.state.name.trim(),
            EnableAccountUsers: this.state.enableAccountUsers,
            EnableEmployees: this.state.enableEmployees,
            EnableLocations: this.state.enableLocations,
            EnableMicroLocations: this.state.enableMicroLocations,
            EnablePositions: this.state.enablePositions,
            DisableExpense: this.state.disableExpense,
            EnablePunches: this.state.enablePunches,
            EnableJob: this.state.enableJob,
            MessageForDisablePunches: !this.state.enablePunches && this.state.messageForDisablePunches.trim()
        }
        this.props.handleSave(newHierarchyDefinitionItem)
    }

    checkValidate() {
        let isValidate = true
        if (!this.state.name.trim()) {
            this.setState({ errorName: strings.This_field_is_required })
            isValidate = false
        }
        else if (this.state.name.trim().length > 50) {
            this.setState({ errorName: strings.Label_length_cannot_exceed_50_characters })
            isValidate = false
        }
        else {
            this.setState({ errorName: "" })
        }

        if (!this.state.messageForDisablePunches.trim()) {
            this.setState({ errorMessageForDisablePunches: strings.This_field_is_required })
            isValidate = false
        }
        else {
            this.setState({ errorMessageForDisablePunches: "" })
        }

        return isValidate
    }

    render() {
        return (
            <Dialog
                modal
                open
                title={strings.Add_New_Hierarchy_Definition}
                actions={[
                    <FlatButton label={strings.Cancel} secondary onTouchTap={this.props.handleClose} />,
                    <FlatButton label={strings.Save} primary keyboardFocused={true} onTouchTap={this.handleSave} />
                ]}
            >
                <TextField
                    name="Label"
                    floatingLabelText={strings.Level_Label}
                    value={this.state.name}
                    style={{ marginLeft: 30, fontSize: 20, fontWeight: "bold" }}
                    onChange={e => this.setState({ name: e.target.value }, () => this.checkValidate())}
                    errorText={this.state.errorName}
                />
                <div style={{ fontSize: 15, marginLeft: 30, marginBottom: 20 }}>
                    {strings.Level} {this.props.candidateLevel + 1}
                </div>
                <Toggle
                    name="EnableLocations"
                    label={strings.Allow_GPS_Locations}
                    toggled={this.state.enableLocations}
                    onToggle={(e, value) => this.setState({ enableLocations: value })}
                    style={{ maxWidth: 250, marginLeft: 30, marginBottom: 20 }}
                    labelStyle={{ fontSize: 15 }}
                />
                <Toggle
                    name="EnableMicroLocations"
                    label={strings.Allow_MicroLocations}
                    toggled={this.state.enableMicroLocations}
                    onToggle={(e, value) => this.setState({ enableMicroLocations: value })}
                    style={{ maxWidth: 250, marginLeft: 30, marginBottom: 20 }}
                    labelStyle={{ fontSize: 15 }}
                />
                {AccountStore.getJobsEnabled() &&
                    <Toggle
                        name="EnableJob"
                        label={checkJobFieldAvailable('singular') ? `Allow ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Allow_Job}
                        toggled={this.state.enableJob}
                        onToggle={(e, value) => this.setState({ enableJob: value })}
                        style={{ maxWidth: 250, marginLeft: 30, marginBottom: 20 }}
                        labelStyle={{ fontSize: 15 }}
                    />
                }
                <Toggle
                    name="EnablePositions"
                    label={checkPositionFieldAvailable('plural') ? `Allow ${accountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel}` : strings.Allow_Positions}
                    toggled={this.state.enablePositions}
                    onToggle={(e, value) => this.setState({ enablePositions: value })}
                    style={{ maxWidth: 250, marginLeft: 30, marginBottom: 20 }}
                    labelStyle={{ fontSize: 15 }}
                    disabled={!this.state.enablePunches}
                />
                {this.props.explicitEmployeeHierarchyAssignment &&
                    <Toggle
                        name="EnableEmployees"
                        label={strings.Allow_Attached_Employees}
                        toggled={this.state.enableEmployees}
                        onToggle={(e, value) => this.setState({ enableEmployees: value })}
                        style={{ maxWidth: 250, marginLeft: 30, marginBottom: 20 }}
                        labelStyle={{ fontSize: 15 }}
                    />
                }
                {this.props.explicitAccountUserHierarchyAssignment &&
                    <Toggle
                        name="EnableAccountUsers"
                        label={strings.Allow_Attached_Users}
                        toggled={this.state.enableAccountUsers}
                        onToggle={(e, value) => this.setState({ enableAccountUsers: value })}
                        style={{ maxWidth: 250, marginLeft: 30, marginBottom: 20 }}
                        labelStyle={{ fontSize: 15 }}
                    />
                }
                {AccountStore.getExpensesEnabled() &&
                    <Toggle
                        name="DisableExpense"
                        label={strings.Disable_Expense}
                        toggled={this.state.disableExpense}
                        onToggle={(e, value) => this.setState({ disableExpense: value })}
                        style={{ maxWidth: 250, marginLeft: 30, marginBottom: 20 }}
                        labelStyle={{ fontSize: 15 }}
                    />
                }
                <Toggle
                    name="EnablePunches"
                    label={strings.Allow_Punches}
                    toggled={this.state.enablePunches}
                    onToggle={(e, value) => this.setState({ enablePunches: value, enablePositions: value ? this.state.enablePositions : false })}
                    style={{ maxWidth: 250, marginLeft: 30, marginBottom: 20 }}
                    labelStyle={{ fontSize: 15 }}
                />
                {!this.state.enablePunches &&
                    <TextField
                        name="MessageForDisablePunches"
                        floatingLabelText={strings.Disable_Message}
                        style={{ width: 600, marginLeft: 30, marginTop: -10 }}
                        value={this.state.messageForDisablePunches}
                        onChange={e => this.setState({ messageForDisablePunches: e.target.value }, () => this.checkValidate())}
                        errorText={this.state.errorMessageForDisablePunches}
                    />
                }
            </Dialog>
        )
    }
}
